import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['title', 'description', 'buttonName', 'dismissLabel']
> = defineContent({
	default: {
		title: {
			id: 'jira-crossflow-recommendation-jsm.banner-title',
			defaultMessage: 'Track and resolve support issues, fast',
			description: 'Title for the JSM crossflow recommendation banner',
			role: 'title',
		},
		description: {
			id: 'jira-crossflow-recommendation-jsm.banner-description',
			defaultMessage:
				'When you use Jira and Jira Service Management together, you can track and resolve requests in one place.',
			description: 'Description for the JSM crossflow recommendation banner',
			role: 'description',
		},
		buttonName: {
			id: 'jira-crossflow-recommendation-jsm.banner-button',
			defaultMessage: 'Try it',
			description: 'CTA button text for the JSM crossflow recommendation banner',
		},
		dismissLabel: {
			id: 'jira-crossflow-recommendation-jsm.banner-dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button label for the JSM crossflow recommendation banner',
		},
	},
});
